import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import logo from '../../../assets/images/NN Logo Final-01.jpg';
import { getUserName } from '../../../util/customMethods';
import HeaderMenu from './headerMenu';
import { getAccessLevelsByModuleName } from '../../../util/customMethods';
import './Header.css';

let reviewPermission = { edit: false, view: false };

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMenuOpen: false,
      hasValidData: false
    };
    this.handleRedirectClick = this.handleRedirectClick.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
  }

  componentDidMount() {
    this.checkDataValidity();
  }

  componentDidUpdate(prevProps) {
    // Re-check when props change
    if (prevProps.accessLevels !== this.props.accessLevels || 
        prevProps.dashboardAccess !== this.props.dashboardAccess) {
      this.checkDataValidity();
    }
  }

  checkDataValidity = () => {
    const { accessLevels, dashboardAccess } = this.props;
    const isValid = !!(accessLevels && dashboardAccess && 
                      Object.keys(accessLevels).length > 0);
    
    if (isValid !== this.state.hasValidData) {
      this.setState({ hasValidData: isValid });
    }
  }

  handleRedirectClick = (base, root, token) => {
    console.log(base, root, token);
    window.location = window.location.origin + base + root;
  }

  handleNoPermission = (e) => {
    e.preventDefault();
    alert("You don't have permission to review the invoice details.");
  }

  toggleMenu = (event) => {
    event.preventDefault();
    const isOpen = document.body.classList.contains('menu-left-opened');
    
    if (isOpen) {
      event.currentTarget.classList.remove('is-active');
      document.body.classList.remove('menu-left-opened');
      document.documentElement.style.overflow = "auto";
      this.setState({ isMenuOpen: false });
    } else {
      event.currentTarget.classList.add('is-active');
      document.body.classList.add('menu-left-opened');
      document.documentElement.style.overflow = "hidden";
      this.setState({ isMenuOpen: true });
    }
  }

  getReviewPermission = () => {
    try {
      let reviewPermissionData = getAccessLevelsByModuleName("Review Invoice");
      if (reviewPermissionData && reviewPermissionData[0]) {
        return reviewPermissionData[0].basicAccess || { edit: false, view: false };
      }
    } catch (error) {
      console.error('Error getting review permission:', error);
    }
    return { edit: false, view: false };
  }

  render() {
    const { reviewInbox, accessLevels, dashboardAccess, onLogOut } = this.props;
    const { hasValidData } = this.state;

    // Get review permission safely
    reviewPermission = this.getReviewPermission();

    // Get username safely
    let userName = 'User';
    try {
      userName = getUserName() || 'User';
    } catch (error) {
      console.error('Error getting username:', error);
    }

    // Safety check for reviewInbox
    const safeReviewInbox = reviewInbox || { reviewedInvoicesCount: 0 };

    return (
      <header className="site-header">
        <div className="container-fluid">
          <Link to="/" className="site-logo-text">
            <img 
              src={logo} 
              alt="navinet" 
              className="block-center img-rounded" 
              style={{ marginRight: '37%' }} 
            />
          </Link>

          <button 
            className="hamburger hamburger--htla" 
            onClick={this.toggleMenu}
            aria-label="Toggle menu"
          >
            <span>toggle menu</span>
          </button>

          <div className="site-header-content">
            <div className="site-header-content-in">
              

              <div className="site-header-shown">
                <div className="dropdown user-menu">
                  <button 
                    className="dropdown-toggle" 
                    id="dd-user-menu" 
                    type="button" 
                    data-toggle="dropdown" 
                    aria-haspopup="true" 
                    aria-expanded="false"
                  >
                    {userName}
                    <img 
                      src={require('../../../assets/images/avatar-2-64.png')} 
                      alt="User avatar" 
                    />
                  </button>

                  <div className="dropdown-menu">
                    <a 
                      className="dropdown-item" 
                      href="#logout"
                      onClick={(e) => {
                        e.preventDefault();
                        if (onLogOut) {
                          onLogOut();
                        } else {
                          console.error('onLogOut prop is missing');
                        }
                      }}
                    >
                      <i className="fa fa-sign-out" aria-hidden="true"></i> Logout
                    </a>
                  </div>
                </div>
              </div>

              <div className="mobile-menu-right-overlay"></div>

              {/* Render HeaderMenu only if data is valid */}
              {hasValidData ? (
                <HeaderMenu 
                  accessLevels={accessLevels || {}} 
                  dashboardAccess={dashboardAccess || {}} 
                  reviewInbox={safeReviewInbox}
                />
              ) : (
                <div className="header-menu-loading">
                  <span style={{ fontSize: '14px', color: '#999' }}>
                    Loading menu...
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>
    );
  }
}

export default Header;